import { render } from "./IconImage.vue?vue&type=template&id=77e1da3c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77e1da3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77e1da3c', __exports__)) {
    api.reload('77e1da3c', __exports__)
  }
  
  module.hot.accept("./IconImage.vue?vue&type=template&id=77e1da3c", () => {
    api.rerender('77e1da3c', render)
  })

}


export default __exports__